import type { FC } from 'react';
import { Box, Typography } from '@mui/material';

import type { DashboardComment } from 'src/types/dashboard';

import CommentTopicBox from './CommentTopicBox';
import SentimentIcon from './SentimentIcon';

import { styles } from './index.styles';

interface CommentsListItemProps {
  comment: DashboardComment;
  isDefaultLanguage: boolean;
}

const CommentsListItem: FC<CommentsListItemProps> = ({
  comment,
  isDefaultLanguage,
}) => (
  <Box sx={styles.commentBox}>
    <Box sx={styles.overallSentiment}>
      <SentimentIcon sentiment={comment.sentimentOverall} />
    </Box>

    <Box sx={styles.comment}>
      <Typography sx={styles.commentText}>
        {isDefaultLanguage ? comment.text : comment.translatedText}
      </Typography>
      <Box sx={styles.commentTopicList}>
        {comment.topics.map((topic) => (
          <CommentTopicBox key={topic.id} topic={topic} />
        ))}
      </Box>
    </Box>
  </Box>
);

export default CommentsListItem;
